import { Component, inject, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../core/services/api/auth.service';
import { MenuitemComponent } from '../menuitem/menuitem.component';
import { ImportMarcacionesService } from '../../core/services/conf/import-marcaciones.service';
import { GnbValidacionModalService } from '../../core/services/conf/gnb-validacion-modal.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-menu',
    imports: [MenuitemComponent, RouterModule],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnDestroy {
    model: MenuItem[] = [];
    private readonly authService = inject(AuthService);
    private readonly importMarcacionesService = inject(ImportMarcacionesService);
    private readonly gnbValidacionModalService = inject(GnbValidacionModalService);

    rolUser = this.authService.getUserRoles();

    private readonly userBranch: string = this.authService.getCurrentUser()?.branch || '';
    private previewSub: Subscription;

    isLaboratoryBranch(): boolean {
        return this.authService.isLaboratoryBranch();
    }

    isCccBranch(): boolean {
        return this.userBranch?.toUpperCase().includes('CCC') || this.userBranch?.toUpperCase().includes('COBRANZA');
    }

    constructor() {
        this.previewSub = this.authService.previewRole$.subscribe(() => {
            this.rolUser = this.authService.getEffectiveRoles();
            this.buildMenu();
        });
    }

    ngOnDestroy(): void {
        this.previewSub?.unsubscribe();
    }

    // haveRole(role: string): boolean {
    //     return this.rolUser.includes(role);
    // }

    hasAnyRole(roles: string[]): boolean {
        return roles.some((r) => this.rolUser.includes(r));
    }

    ngOnInit() {
        this.buildMenu();
    }

    private buildMenu(): void {
        this.model = [
            {
                label: 'Inicio',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-gauge',
                        routerLink: ['/sys/dashboard']
                    }
                ]
            },
            {
                label: 'Secciones',
                items: [
                    {
                        label: 'Carga de Datos',
                        icon: 'pi pi-fw pi-cog',
                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                        items: [
                            {
                                label: 'Pacientes',
                                icon: 'pi pi-fw pi-users',
                                visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                routerLink: ['/sys/identity/patient/list']
                                // items: [
                                //     {
                                //         label: 'Nuevo',
                                //         icon: 'pi pi-fw pi-sign-in',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('ROOT'),
                                //         routerLink: ['/sys/identity/patient/create']
                                //     },
                                //     {
                                //         label: 'Listar',
                                //         icon: 'pi pi-fw pi-times-circle',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('ROOT'),
                                //         routerLink: ['/sys/identity/patient/list']
                                //     }
                                // ]
                            },
                            {
                                label: 'Doctores',
                                icon: 'pi pi-fw pi-address-book',
                                visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                routerLink: ['/sys/identity/doctor/list']
                                //   items: [
                                //     {
                                //       label: 'Nuevo',
                                //       icon: 'pi pi-fw pi-sign-in',
                                //       visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('ROOT'),
                                //       routerLink: ['/sys/identity/doctor/create'],
                                //     },
                                //     {
                                //       label: 'Listar',
                                //       icon: 'pi pi-fw pi-times-circle',
                                //       visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('ROOT'),
                                //       routerLink: ['/sys/identity/doctor/list'],
                                //     },
                                //   ]
                            },
                            {
                                label: 'Seguros',
                                icon: 'pi pi-fw pi-building-columns',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR', 'ENCARGADO', 'RADIOLOGO', 'SECRETARIA', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                items: [
                                    {
                                        label: 'Listar Seguros',
                                        icon: 'pi pi-fw pi-list',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR', 'ENCARGADO', 'RADIOLOGO', 'SECRETARIA', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                        routerLink: ['/sys/identity/secure/list']
                                    },
                                    {
                                        label: 'Sucursales',
                                        icon: 'pi pi-fw pi-lock',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR', 'ENCARGADO', 'RADIOLOGO', 'SECRETARIA', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                        routerLink: ['/sys/identity/secure/subsidiaries']
                                    }
                                ]
                            },
                            {
                                label: 'Usuarios',
                                icon: 'pi pi-fw pi-user',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/identity/user/list']
                                // items: [
                                //     {
                                //         label: 'Nuevo',
                                //         icon: 'pi pi-fw pi-sign-in',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('ROOT'),
                                //         routerLink: ['/sys/identity/user/create']
                                //     },
                                //     {
                                //         label: 'Listar',
                                //         icon: 'pi pi-fw pi-times-circle',
                                //         visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('ROOT'),
                                //         routerLink: ['/sys/identity/user/list']
                                //     }
                                // ]
                            }
                        ]
                    },
                    {
                        label: 'Atención - Órdenes',
                        icon: 'pi pi-fw pi-inbox',
                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                        items: [
                            {
                                label: 'Ordenes',
                                icon: 'pi pi-fw pi-receipt',
                                visible: (!this.isLaboratoryBranch() && this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA'])) || this.hasAnyRole(['MKTADM', 'MKTASIST', 'MKTLAB']),
                                items: [
                                    {
                                        label: 'Nueva',
                                        icon: 'pi pi-fw pi-sign-in',
                                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                                        routerLink: ['/sys/clinical/new']
                                    },
                                    {
                                        label: 'Generadas',
                                        icon: 'pi pi-fw pi-database',
                                        visible: this.hasAnyRole(['ROOT', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                                        routerLink: ['/sys/clinical/pendiente']
                                    },
                                    {
                                        label: 'Resultados',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.hasAnyRole(['ROOT', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                                        routerLink: ['/sys/clinical/resultado']
                                    },
                                    {
                                        label: 'Listado',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                        routerLink: ['/sys/clinical/list']
                                    }
                                ]
                            },
                            {
                                label: 'Ordenes - Laboratorio',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                items: [
                                    {
                                        label: 'Nueva',
                                        icon: 'pi pi-fw pi-sign-in',
                                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                                        routerLink: ['/sys/clinical/new-laboratory']
                                    },
                                    {
                                        label: 'Generadas',
                                        icon: 'pi pi-fw pi-database',
                                        visible: this.isLaboratoryBranch() && this.hasAnyRole(['ROOT', 'RADIOLOGO', 'ENCARGADO', 'SECRETARIA', 'RRHH', 'COBRANZA']),
                                        routerLink: ['/sys/clinical/pendent-laboratory']
                                    },
                                    // {
                                    //     label: 'Generadas Sucursales',
                                    //     icon: 'pi pi-fw pi-database',
                                    //     visible: this.isLaboratoryBranch() && (this.hasAnyRole(['ROOT', 'RADIOLOGO', 'ENCARGADO']) || this.haveRole('SECRETARIA')),
                                    //     routerLink: ['/sys/clinical/pendent-branch-laboratory']
                                    // },
                                    {
                                        label: 'Resultados',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.hasAnyRole(['ROOT', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                                        routerLink: ['/sys/clinical/result-laboratory']
                                    },
                                    {
                                        label: 'Listado',
                                        icon: 'pi pi-fw pi-check-circle',
                                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                        routerLink: ['/sys/clinical/list-laboratory']
                                    },
                                    {
                                        label: 'Entrega de Trabajos',
                                        icon: 'pi pi-fw pi-box',
                                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'CONTADOR', 'ADMIN']),
                                        routerLink: ['/sys/clinical/entrega-trabajos']
                                    },
                                    {
                                        label: 'Tablero de Control',
                                        icon: 'pi pi-fw pi-table',
                                        visible: this.isLaboratoryBranch() && this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                                        routerLink: ['/sys/clinical/board-laboratory']
                                    }
                                ]
                            },
                            {
                                label: 'Anulaciones',
                                icon: 'pi pi-fw pi-ban',
                                visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA', 'CONTADOR', 'MKTADM']),
                                routerLink: ['/sys/clinical/anulaciones']
                            },
                            {
                                label: 'Historial',
                                icon: 'pi pi-fw pi-history',
                                visible: false,
                                items: [
                                    {
                                        label: 'Pacientes',
                                        icon: 'pi pi-fw pi-users',
                                        visible: false,
                                        routerLink: ['/sys/clinical/history/patients']
                                    },
                                    {
                                        label: 'Doctores',
                                        icon: 'pi pi-fw pi-address-book',
                                        visible: false,
                                        routerLink: ['/sys/clinical/history/doctors']
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        label: 'Cobranzas',
                        icon: 'pi pi-fw pi-credit-card',
                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA']) || this.isCccBranch(),
                        items: [
                            {
                                label: 'Pendientes de Cobro',
                                icon: 'pi pi-fw pi-clock',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/pending-payment']
                            },
                            {
                                label: 'Verificados',
                                icon: 'pi pi-fw pi-check-circle',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/verified-payment']
                            },
                            {
                                label: 'Edición Ordenes',
                                icon: 'pi pi-fw pi-pencil',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/edicion-ordenes']
                            },
                            {
                                label: 'Emitir Factura M',
                                icon: 'pi pi-fw pi-file-plus',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/emit-invoice']
                            },
                            {
                                label: 'Emitir NC',
                                icon: 'pi pi-fw pi-file-edit',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA', 'CONTADOR', 'RRHH']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/list-nc']
                            },
                            {
                                label: 'Retenciones IVA',
                                icon: 'pi pi-fw pi-percentage',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/retenciones-iva']
                            },
                            {
                                label: 'Facturas',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA', 'CONTADOR']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/invoices']
                            },
                            {
                                label: 'Facturas Sistema ARCO 2.0',
                                icon: 'pi pi-fw pi-upload',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA', 'CONTADOR']) || this.isCccBranch(),
                                routerLink: ['/sys/clinical/collections/import-invoices']
                            }
                        ]
                    },

                    {
                        label: 'Compras / Proveedores',
                        icon: 'pi pi-fw pi-shopping-cart',
                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'ENCARGADO', 'RADIOLOGO', 'CONTADOR']),
                        items: [
                            {
                                label: 'Órdenes de Compra/Pago',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'ENCARGADO', 'RADIOLOGO']),
                                routerLink: ['/sys/purchase-orders']
                            },
                            {
                                label: 'Ordenes Sucursales',
                                icon: 'pi pi-fw pi-building',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR', 'RRHH']),
                                routerLink: ['/sys/purchase-orders/sucursales']
                            }
                        ]
                    },
                    // {
                    //     label: 'Facturación',
                    //     icon: 'pi pi-fw pi-user',
                    //     visible: this.hasAnyRole(['ROOT']),
                    //     items: [
                    //         {
                    //             label: 'Cobranza',
                    //             icon: 'pi pi-fw pi-sign-in',
                    //             visible: this.hasAnyRole(['ROOT']),
                    //             // routerLink: ['/auth/login'],
                    //         },
                    //         {
                    //             label: 'Facturas',
                    //             icon: 'pi pi-fw pi-times-circle',
                    //             visible: this.hasAnyRole(['ROOT']),
                    //             // routerLink: ['/auth/error'],
                    //         },
                    //         {
                    //             label: 'Recibos',
                    //             icon: 'pi pi-fw pi-lock',
                    //            visible: this.hasAnyRole(['ROOT']),
                    //             // routerLink: ['/auth/access'],
                    //         },
                    //         {
                    //             label: 'Depósitos',
                    //             icon: 'pi pi-fw pi-lock',
                    //             visible: this.hasAnyRole(['ROOT']),
                    //             // routerLink: ['/auth/access'],
                    //         }
                    //     ]
                    // },
                    {
                        label: 'Reportes',
                        icon: 'pi pi-fw pi-chart-line',
                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RADIOLOGO', 'ENCARGADO', 'CONTADOR', 'RRHH', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                        items: [
                            {
                                label: 'Órdenes Facturadas',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN']),
                                routerLink: ['/sys/reports/invoiced-orders-report']
                            },
                            {
                                label: 'Morosos',
                                icon: 'pi pi-fw pi-exclamation-triangle',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA', 'CONTADOR']),
                                routerLink: ['/sys/reports/morosos']
                            },
                            {
                                label: 'Pacientes Mensuales',
                                icon: 'pi pi-fw pi-users',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RADIOLOGO', 'ENCARGADO']),
                                routerLink: ['/sys/reports/monthly-patients-report']
                            },
                            {
                                label: 'Pacientes Mensuales Global',
                                icon: 'pi pi-fw pi-users',
                                visible: this.hasAnyRole(['ADMIN', 'ROOT', 'RRHH', 'CONTADOR', 'MKTADM', 'MKTASIST', 'MKTLAB']),
                                routerLink: ['/sys/reports/monthly-patients-global-report']
                            },
                            {
                                label: 'Comisiones',
                                icon: 'pi pi-fw pi-dollar',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR', 'RRHH', 'MKTADM']),
                                items: [
                                    {
                                        label: 'Por Sucursal',
                                        icon: 'pi pi-fw pi-building',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR', 'RRHH', 'MKTADM']),
                                        routerLink: ['/sys/reports/comisiones/por-sucursal']
                                    },
                                    {
                                        label: 'Por Personal',
                                        icon: 'pi pi-fw pi-user',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR', 'RRHH', 'MKTADM']),
                                        routerLink: ['/sys/reports/comisiones/por-personal']
                                    }
                                ]
                            },
                            {
                                label: 'Marketing',
                                icon: 'pi pi-fw  pi-chart-pie',
                                visible: this.hasAnyRole(['MKTADM', 'MKTASIST', 'ROOT', 'ADMIN']),
                                items: [
                                    { label: 'Total Pacientes', icon: 'pi pi-fw pi-users', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/total-patients'] },
                                    { label: 'Por Seguro/Particular', icon: 'pi pi-fw pi-building-columns', visible: this.hasAnyRole(['MKTADM', 'MKTASIST', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/by-secure'] },
                                    { label: 'Médicos', icon: 'pi pi-fw pi-address-book', visible: this.hasAnyRole(['MKTADM', 'MKTASIST', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/doctors'] },
                                    { label: 'Órdenes Gentileza', icon: 'pi pi-fw pi-heart', visible: this.hasAnyRole(['MKTADM', 'MKTASIST', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/kindness'] },
                                    { label: 'Órdenes Anuladas', icon: 'pi pi-fw pi-times-circle', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/cancelled'] },
                                    { label: 'Estudios Repetidos', icon: 'pi pi-fw pi-replay', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/repeated'] },
                                    { label: 'Historial Pacientes', icon: 'pi pi-fw pi-history', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/history'] },
                                    { label: 'Nuevos vs Recurrentes', icon: 'pi pi-fw pi-user-plus', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/new-vs-returning'] },
                                    { label: 'Top Estudios', icon: 'pi pi-fw pi-star', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/top-studies'] },
                                    { label: 'Top por Categorías', icon: 'pi pi-fw pi-star', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/top-categories'] },
                                    { label: 'Tendencia Mensual', icon: 'pi pi-fw pi-chart-line', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/trend'] },
                                    { label: 'Médicos por Volumen', icon: 'pi pi-fw pi-sort-amount-down', visible: this.hasAnyRole(['MKTADM', 'MKTASIST', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/doctors-volume'] },
                                    { label: 'Estudio por Sucursal', icon: 'pi pi-fw pi-building', visible: this.hasAnyRole(['MKTADM', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/study-by-branch'] },
                                    { label: 'Vouchers Gentileza', icon: 'pi pi-fw pi-ticket', visible: this.hasAnyRole(['MKTADM', 'MKTASIST', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/vouchers-gentileza'] },
                                    { label: 'Estadísticas', icon: 'pi pi-fw pi-chart-line', visible: this.hasAnyRole(['MKTADM', 'MKTASIST', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/statistics'] }
                                ]
                            },
                            {
                                label: 'Marketing Laboratorio',
                                icon: 'pi pi-fw pi-chart-scatter',
                                visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']),
                                items: [
                                    { label: 'Total Pacientes Lab.', icon: 'pi pi-fw pi-users', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/total-patients'] },
                                    { label: 'Por Seguro Lab.', icon: 'pi pi-fw pi-building-columns', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/by-secure'] },
                                    { label: 'Médicos Lab.', icon: 'pi pi-fw pi-address-book', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/doctors'] },
                                    { label: 'Gentileza Lab.', icon: 'pi pi-fw pi-heart', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/kindness'] },
                                    { label: 'Anuladas Lab.', icon: 'pi pi-fw pi-times-circle', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/cancelled'] },
                                    { label: 'Repetidos Lab.', icon: 'pi pi-fw pi-replay', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/repeated'] },
                                    { label: 'Historial Lab.', icon: 'pi pi-fw pi-history', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/history'] },
                                    { label: 'Nuevos vs Recurrentes Lab.', icon: 'pi pi-fw pi-user-plus', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/new-vs-returning'] },
                                    { label: 'Top Estudios Lab.', icon: 'pi pi-fw pi-star', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/top-studies'] },
                                    { label: 'Top por Categorías Lab.', icon: 'pi pi-fw pi-star', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/top-categories'] },
                                    { label: 'Tendencia Lab.', icon: 'pi pi-fw pi-chart-line', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/trend'] },
                                    { label: 'Médicos Volumen Lab.', icon: 'pi pi-fw pi-sort-amount-down', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/doctors-volume'] },
                                    { label: 'Estudio por Sucursal Lab.', icon: 'pi pi-fw pi-building', visible: this.hasAnyRole(['MKTADM', 'MKTLAB', 'ROOT', 'ADMIN']), routerLink: ['/sys/marketing/lab/study-by-branch'] }
                                ]
                            },
                            {
                                label: 'Contabilidad',
                                icon: 'pi pi-fw pi-briefcase',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR']),
                                items: [
                                    {
                                        label: 'Facturaciones',
                                        icon: 'pi pi-fw pi-list',
                                        visible: this.hasAnyRole(['ROOT']),
                                        routerLink: ['/sys/contabilidad/invoices-full']
                                    },
                                    {
                                        label: 'Ordenes',
                                        icon: 'pi pi-fw pi-list',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR']),
                                        routerLink: ['/sys/contabilidad/orders-full']
                                    },
                                    {
                                        label: 'Reportes Facturas',
                                        icon: 'pi pi-fw pi-chart-bar',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR']),
                                        routerLink: ['/sys/contabilidad/reportes-facturas']
                                    },
                                    {
                                        label: 'Arqueo Compras',
                                        icon: 'pi pi-fw pi-calculator',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR']),
                                        routerLink: ['/sys/contabilidad/arqueo-compras']
                                    },
                                    {
                                        label: 'Estadísticas MKT',
                                        icon: 'pi pi-fw pi-chart-line',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR']),
                                        routerLink: ['/sys/contabilidad/estadisticas-mkt']
                                    },
                                    {
                                        label: 'Notas de Crédito',
                                        icon: 'pi pi-fw pi-file-edit',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR']),
                                        routerLink: ['/sys/contabilidad/credit-note']
                                    },
                                    {
                                        label: 'Conciliación Bancard',
                                        icon: 'pi pi-fw pi-credit-card',
                                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'COBRANZA', 'CONTADOR']),
                                        routerLink: ['/sys/bancard']
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        label: 'Caja Chica',
                        icon: 'pi pi-fw pi-money-bill',
                        visible: this.hasAnyRole(['ROOT', 'ENCARGADO', 'RRHH', 'RADIOLOGO', 'CONTADOR']),
                        items: [
                            {
                                label: 'Movimientos',
                                icon: 'pi pi-fw pi-times-circle',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'ENCARGADO', 'RADIOLOGO']),
                                routerLink: ['/sys/cash/petty-cash']
                            },
                            {
                                label: 'Aprobación Caja Chica',
                                icon: 'pi pi-fw pi-check-circle',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR']),
                                routerLink: ['/sys/cash/petty-cash/approval']
                            },
                            {
                                label: 'Verificación de Cajas',
                                icon: 'pi pi-fw pi-shield',
                                visible: false,
                                routerLink: ['/sys/cashier-reports/verification']
                            }
                        ]
                    },
                    {
                        label: 'RRHH',
                        icon: 'pi pi-fw pi-id-card',
                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR']),
                        items: [
                            {
                                label: 'Personal',
                                icon: 'pi pi-fw pi-address-book',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR']),
                                routerLink: ['/sys/rrhh/personal/list']
                            },
                            {
                                label: 'Horarios',
                                icon: 'pi pi-fw pi-calendar',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR']),
                                routerLink: ['/sys/rrhh/work-schedules']
                            },
                            {
                                label: 'Importar Marcaciones',
                                icon: 'pi pi-fw pi-file-excel',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR']),
                                routerLink: ['/sys/rrhh/import-marcaciones']
                            },
                            {
                                label: 'Liquidación de Sueldos',
                                icon: 'pi pi-fw pi-money-bill',
                                visible: this.hasAnyRole(['ROOT', 'ADMIN', 'RRHH', 'CONTADOR']),
                                routerLink: ['/sys/rrhh/payroll']
                            }
                        ]
                    }
                ]
            },
            {
                label: 'Cajeros',
                visible: !this.hasAnyRole(['MKTADM', 'MKTASIST', 'MKTLAB']),
                items: [
                    {
                        label: 'Caja',
                        icon: 'pi pi-fw pi-sign-in',
                        visible: this.hasAnyRole(['ROOT', 'SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                        routerLink: ['/sys/cashier']
                    },
                    {
                        label: 'Aprobación de cajas',
                        icon: 'pi pi-fw pi-check',
                        visible: this.hasAnyRole(['ROOT', 'RADIOLOGO', 'ENCARGADO', 'RRHH', 'COBRANZA']),
                        routerLink: ['/sys/cashier-reports/approval']
                    },
                    {
                        label: 'Verificación de cajas',
                        icon: 'pi pi-fw pi-shield',
                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'CONTADOR', 'RRHH']),
                        routerLink: ['/sys/cashier-reports/verification']
                    }
                ]
            },

            {
                label: 'EXTRAS',
                items: [
                    {
                        label: 'Presupuesto',
                        icon: 'pi pi-fw pi-calculator',
                        visible: !this.hasAnyRole(['INVITADO']),
                        routerLink: ['/sys/clinical/order-price']
                    },
                    {
                        label: 'Validación de Transferencias',
                        icon: 'pi pi-fw pi-check-circle',
                        command: () => this.gnbValidacionModalService.open()
                    },
                    {
                        label: 'Validador Pruebas',
                        icon: 'pi pi-fw pi-check-circle',
                        visible: this.hasAnyRole(['ROOT']),
                        routerLink: ['/sys/gnb']
                    },
                    {
                        label: 'Importar Marcaciones',
                        icon: 'pi pi-fw pi-file-excel',
                        visible: this.hasAnyRole(['ROOT', 'ADMIN', 'ENCARGADO', 'RADIOLOGO', 'RRHH', 'CONTADOR']),
                        command: () => this.importMarcacionesService.open()
                    },
                    {
                        label: 'Configuraciónes',
                        icon: 'pi pi-fw pi-cog',
                        visible: this.hasAnyRole(['ROOT']),
                        items: [
                            {
                                label: 'Roles',
                                icon: 'pi pi-fw pi-shield',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/access']
                            },
                            {
                                label: 'Estudios',
                                icon: 'pi pi-fw pi-ticket',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/studies']
                            },
                            {
                                label: 'Proveedores',
                                icon: 'pi pi-fw pi-truck',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/suppliers']
                            },
                            // {
                            //     label: 'Estados',
                            //     icon: 'pi pi-fw pi-list',
                            //     visible: this.haveRole('warehouse_operator') || this.haveRole('delivery_person') || this.haveRole('manager') || this.haveRole('admin') || this.haveRole('ROOT'),
                            //     routerLink: ['/sys/settings/status']
                            // },
                            {
                                label: 'Categorías',
                                icon: 'pi pi-fw pi-list-check',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/category']
                            },
                            {
                                label: 'Sucursales',
                                icon: 'pi pi-fw pi-building-columns',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/sucursales']
                            },
                            {
                                label: 'Empresas',
                                icon: 'pi pi-fw pi-building',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/companies']
                            },
                            {
                                label: 'Feriados',
                                icon: 'pi pi-fw pi-calendar',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/feriados']
                            },
                            {
                                label: 'Tipos / Estados',
                                icon: 'pi pi-fw pi-bookmark',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/tipo']
                            },
                            {
                                label: 'Timbrados',
                                icon: 'pi pi-fw pi-receipt',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/timbrado']
                            },
                            {
                                label: 'Documentos',
                                icon: 'pi pi-fw pi-file',
                                visible: this.hasAnyRole(['ROOT']),
                                items: [
                                    {
                                        label: 'Facturas',
                                        icon: 'pi pi-fw pi-receipt',
                                        visible: this.hasAnyRole(['ROOT']),
                                        routerLink: ['/sys/settings/documentos/factura']
                                    },
                                    {
                                        label: 'Recibos',
                                        icon: 'pi pi-fw pi-money-bill',
                                        visible: this.hasAnyRole(['ROOT']),
                                        routerLink: ['/sys/settings/documentos/recibo']
                                    },
                                    {
                                        label: 'Nota de Crédito',
                                        icon: 'pi pi-fw pi-file-edit',
                                        visible: this.hasAnyRole(['ROOT']),
                                        routerLink: ['/sys/settings/documentos/nota-credito']
                                    }
                                ]
                            },
                            {
                                label: 'Enví­o Masivo',
                                icon: 'pi pi-fw pi-send',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/settings/bulk-send']
                            },
                            {
                                label: 'Acerca de',
                                icon: 'pi pi-fw pi-id-card',
                                visible: this.hasAnyRole(['ROOT']),
                                routerLink: ['/sys/auth/access']
                            }
                        ]
                    },
                    {
                        label: 'Aplicaciones',
                        icon: 'pi pi-fw pi-external-link',
                        items: [
                            {
                                label: 'Sitio Web',
                                icon: 'pi pi-fw pi-warehouse',
                                url: 'https://www.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Manual de Usuario',
                                icon: 'pi pi-fw pi-book',
                                routerLink: ['/sys/aplicaciones/manual']
                            },
                            {
                                label: 'Documentación ARCO 3.0',
                                icon: 'pi pi-fw pi-book',
                                routerLink: ['/sys/aplicaciones/documentacion-arco']
                            },
                            {
                                label: 'Tickets',
                                icon: 'pi pi-fw pi-ticket',
                                routerLink: ['/sys/aplicaciones/tickets-lumat']
                            },
                            {
                                label: 'App Informes',
                                icon: 'pi pi-fw pi-clipboard',
                                routerLink: ['/sys/aplicaciones/informes-arco']
                            },
                            {
                                label: 'Odonto Arco',
                                icon: 'pi pi-fw pi-graduation-cap',
                                url: 'https://doctores.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'App Pacientes',
                                icon: 'pi pi-fw pi-user',
                                url: 'https://pacientes.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Tienda Arco',
                                icon: 'pi pi-fw pi-gift',
                                url: 'https://pacientes.arco.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Avancemos',
                                icon: 'pi pi-fw pi-dollar',
                                url: 'https://sys.avancemos.com.py',
                                target: '_blank'
                            },
                            {
                                label: 'Distrident',
                                icon: 'pi pi-fw pi-shop',
                                url: 'https://sys.distrident.com.py',
                                target: '_blank'
                            }
                        ]
                    }
                ]
            }
        ];
    }
}
